import React, { Fragment, useRef, useState } from "react";
import { Select, Input, Button, Space, Row } from "antd";
import type { SelectProps } from "antd";
import { useController } from "react-hook-form";
import styles from "./TNSelect.module.scss";
import ErrorMessage from "../ErrorMessage";
import ConditionalRender from "../ConditionalRender";

interface CustomRenderSelectFieldProps {
  items: string[];
  setItems: React.Dispatch<React.SetStateAction<string[]>>;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  nameAttr?: string;
  value: string;
  isErrorMsg?: boolean;
}

const CustomRenderSelectField: React.FC<
  CustomRenderSelectFieldProps & SelectProps
> = ({
  items,
  setItems,
  name,
  setName,
  placeholder = "Choose",
  nameAttr = "dropdown",
  value,
  isErrorMsg = false,
}) => {
  const {
    field,
    fieldState: { error: validationError },
  } = useController({ name: nameAttr, rules: { required: "required" } });
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value);

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);
  const handleChange = (value: string | undefined) => {
    field.onChange(value);
    setSelectedValue(value);
  };

  const addItem = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    if (name) {
      field.onChange(name);
      setItems([...items, name]);
      setSelectedValue(name);
      setName("");
    }
  };

  return (
    <Row>
      <div className={styles.selectWrapper}>
        <Select
          {...field}
          dropdownStyle={{ minWidth: 200 }}
          name={nameAttr}
          bordered={false}
          placeholder={
            <span>
              {placeholder} <span className={styles.RedAsterik}>{"*"}</span>
            </span>
          }
          value={selectedValue}
          onChange={handleChange}
          onSelect={handleChange}
          onClear={() => setSelectedValue(undefined)}
          dropdownRender={(menu) => (
            <Fragment>
              {menu}
              <Space style={{ padding: "0 8px 4px" }}>
                <Input
                  placeholder="Other value"
                  value={name}
                  onChange={onNameChange}
                  onKeyDown={(e) => e.stopPropagation()}
                  className={styles.CustomSelectInput}
                />
                <Button type="text" onClick={addItem}>
                  Add
                </Button>
              </Space>
            </Fragment>
          )}
          options={items.map((item) => ({ label: item, value: item }))}
          allowClear={true}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        />
        <ConditionalRender visible={isErrorMsg}>
          <div className={styles.selectErrorWrapper}>
            {!selectedValue && <ErrorMessage message={"required"} />}
          </div>
        </ConditionalRender>
      </div>
    </Row>
  );
};

export default CustomRenderSelectField;
